import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatOnboardingContent.css';

interface IChatOnboardingContentProps {
  minWidth?: '160px' | 'auto';
  maxWidth?: '115px' | 'auto';
}

export const ChatOnboardingContent: React.FC<React.PropsWithChildren<IChatOnboardingContentProps>> = ({
  children,
  minWidth = 'auto',
  maxWidth = 'auto',
}) => {
  return (
    <div
      className={styles['content']}
      style={{ ['--content-min-width' as string]: minWidth, ['--content-max-width' as string]: maxWidth }}
    >
      <UIText2 color="text-inverted-default" whiteSpace="pre-line">
        {children}
      </UIText2>
    </div>
  );
};
